import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {
    PowerupButtonAssignment,
    powerupButtonAssignments,
} from '../ui/components/powerup-button.js';
import {Puzzle} from './puzzle.js';
import {GameFlowController} from './game-flow-controller.js';
import {GameModeType} from '../enums/GameModeType.js';
import {Statistics} from './statistics.js';
import {TransactionalNames} from '../enums/TransactionalNames.js';
import {PowerupPerk} from '../classes/PowerupPerk.js';
import {TNTPowerupPerk} from '../classes/powerupPerks/TNTPowerupPerk.js';
import {RainbowfruitPowerupPerk} from '../classes/powerupPerks/RainbowfruitPowerupPerk.js';
import {ChainBoosterPerk} from '../classes/powerupPerks/ScoreBonusPerk.js';

// TK: The data below was defined in the behavior in Unity, but since we can't have arrays for
// properties it's hardcoded for now.
const normalPowerups: TransactionalNames[] = [
    TransactionalNames.BombUpgrade,
    TransactionalNames.FruitSmasherUpgrade,
    TransactionalNames.ForcefieldUpgrade,
    TransactionalNames.NukeUpgrade,
];

const timedPowerups: TransactionalNames[] = [
    TransactionalNames.BombUpgrade,
    TransactionalNames.FruitSmasherUpgrade,
    TransactionalNames.ForcefieldUpgrade,
    TransactionalNames.ClockMagnetUpgrade,
];

const skullPowerups: TransactionalNames[] = [
    TransactionalNames.BombUpgrade,
    TransactionalNames.FruitSmasherUpgrade,
    TransactionalNames.ForcefieldUpgrade,
    TransactionalNames.CountdownDestroyUpgrade,
];

const fungusPowerups: TransactionalNames[] = [
    TransactionalNames.BombUpgrade,
    TransactionalNames.FruitSmasherUpgrade,
    TransactionalNames.ForcefieldUpgrade,
    TransactionalNames.MushroomPopperUpgrade,
];

export class PowerupManager extends Component {
    static TypeName = 'powerup-manager';

    // Singleton
    private static _instance: PowerupManager;

    static get instance(): PowerupManager {
        return PowerupManager._instance;
    }

    ingameSlot1?: PowerupButtonAssignment;
    ingameSlot2?: PowerupButtonAssignment;
    ingameSlot3?: PowerupButtonAssignment;
    ingameSlot4?: PowerupButtonAssignment;

    _gamePowerup1: PowerupButtonAssignment;
    _gamePowerup2: PowerupButtonAssignment;
    _gamePowerup3: PowerupButtonAssignment;
    _gamePowerup4: PowerupButtonAssignment;

    private _gameMode: GameModeType;
    private _unlockMap: Map<TransactionalNames, PowerupButtonAssignment> = new Map();
    private _lockedPowerup: PowerupButtonAssignment;
    private _powerupPerkList: PowerupPerk[] = [
        new TNTPowerupPerk(),
        new RainbowfruitPowerupPerk(),
        new ChainBoosterPerk(),
    ];

    init() {
        if (PowerupManager._instance) {
            console.error('There can only be one instance of PowerupManager Component');
        }
        PowerupManager._instance = this;
    }

    start() {
        Puzzle.instance.registerNewGameCallback(this._newGameCallback);
        Puzzle.instance.registerResetGameCallback(this._resetGameCallback);

        // what mode is selected?
        this._gameMode = GameFlowController.instance.gameMode;

        for (let i = 0; i < powerupButtonAssignments.length; i++) {
            if (powerupButtonAssignments[i].powerupStat !== null) {
                this._unlockMap.set(
                    powerupButtonAssignments[i].powerupStat,
                    powerupButtonAssignments[i]
                );
            } else {
                this._lockedPowerup = powerupButtonAssignments[i];
            }
        }
    }

    update(dt: number) {}

    private _newGameCallback = (puzzle: Puzzle) => {
        this._assignIngamePowerup();
        // TK: This is originally triggerd by 'closing the pause menu' in Unity
        this.showPowerups();

        // if (gameMode != GameFlowController.GameModeType.Tutorial)
        // {
        // 	spawnedFreezeDropButton =  NGUITools.AddChild(freezeDropParent, buyFreezeDrop);
        // 	spawnedFreezeDropButton.transform.position = locFreezeDrop.transform.position ;

        // }

        // if (gamePowerup1 != null)
        // {
        // 	ingamePowerup1 = NGUITools.AddChild(powerupParent, gamePowerup1);
        // 	ingamePowerup1.transform.position = ingameSlot1.transform.position ;
        // 	ingamePowerup1.transform.localScale = scaleOfButtons;

        // }
        // if (gamePowerup2 != null)
        // {
        // 	ingamePowerup2 = NGUITools.AddChild(powerupParent, gamePowerup2);
        // 	ingamePowerup2.transform.position = ingameSlot2.transform.position ;
        // 	ingamePowerup2.transform.localScale = scaleOfButtons;

        // }
        // if (gamePowerup3 != null)
        // {
        // 	ingamePowerup3 = NGUITools.AddChild(powerupParentLeftSide, gamePowerup3);
        // 	ingamePowerup3.transform.position = ingameSlot3.transform.position ;
        // 	ingamePowerup3.transform.localScale = scaleOfButtons;

        // }

        // if (gamePowerup4 != null)
        // {
        // 	ingamePowerup4 = NGUITools.AddChild(powerupParentLeftSide, gamePowerup4);
        // 	ingamePowerup4.transform.position = ingameSlot4.transform.position ;
        // 	ingamePowerup4.transform.localScale = scaleOfButtons;

        // }

        // run through all the perks and spawn the ones that are available
        // TK: This implementation is slightly different from the original, because of the
        // way Wonderland handles components, and the fact that the data is static.
        for (let i = 0; i < this._powerupPerkList.length; i++) {
            let upgradeLevel = Statistics.instance.getTransactional(
                this._powerupPerkList[i].perkStat
            );
            if (upgradeLevel > 0) {
                this._powerupPerkList[i].execute();
            }
        }
    };

    private _resetGameCallback = (puzzle: Puzzle) => {
        this.hidePowerups();

        // clear the queue
        // for (int x = 0; x < spawnedPerks.Count; x++)
        //     {
        //         Destroy(spawnedPerks[x]);
        //         spawnedPerks[x] = null;
        //     }

        //     spawnedPerks.Clear();
    };

    private _assignIngamePowerup() {
        // what mode is selected?
        this._gameMode = GameFlowController.instance.gameMode;

        // this.gamePowerup1 = null;
        // this.gamePowerup2 = null;
        // this.gamePowerup3 = null;
        // this.gamePowerup4 = null;

        // this.ingamePowerup1 = null;
        // this.ingamePowerup2 = null;
        // this.ingamePowerup3 = null;
        // this.ingamePowerup4 = null;

        switch (this._gameMode) {
            case GameModeType.Easy:
            case GameModeType.Normal:
            case GameModeType.Quickplay:
            case GameModeType.Zen:
            case GameModeType.Cupcake:
                for (let i = 0; i < normalPowerups.length; i++) {
                    //if you have been unlocked
                    if (Statistics.instance.getTransactional(normalPowerups[i]) > 0) {
                        this._setupIngamePowerup(normalPowerups[i], i);
                    } else {
                        this._setupLockedPowerup(i);
                    }
                }

                break;

            case GameModeType.Fungus:
                for (let i = 0; i < normalPowerups.length; i++) {
                    //if you have been unlocked
                    if (Statistics.instance.getTransactional(fungusPowerups[i]) > 0) {
                        this._setupIngamePowerup(fungusPowerups[i], i);
                    } else {
                        this._setupLockedPowerup(i);
                    }
                }

                break;

            case GameModeType.Survival:
                for (let i = 0; i < skullPowerups.length; i++) {
                    //if you have been unlocked
                    if (Statistics.instance.getTransactional(skullPowerups[i]) > 0) {
                        this._setupIngamePowerup(skullPowerups[i], i);
                    } else {
                        this._setupLockedPowerup(i);
                    }
                }
                break;

            case GameModeType.Timed:
                for (let i = 0; i < timedPowerups.length; i++) {
                    //if you have been unlocked
                    if (Statistics.instance.getTransactional(timedPowerups[i]) > 0) {
                        this._setupIngamePowerup(timedPowerups[i], i);
                    } else {
                        this._setupLockedPowerup(i);
                    }
                }
                break;

            case GameModeType.Tutorial:
                break;
        }
    }

    private _setupIngamePowerup(stat: TransactionalNames, slot: number) {
        const powerup = this._unlockMap.get(stat);
        if (!powerup) {
            this._setupLockedPowerup(slot);
            return;
        }
        switch (slot) {
            case 0:
                this._gamePowerup1 = powerup;
                break;

            case 1:
                this._gamePowerup2 = powerup;
                break;

            case 2:
                this._gamePowerup3 = powerup;
                break;

            case 3:
                this._gamePowerup4 = powerup;
                break;
        }
    }

    private _setupLockedPowerup(slot: number) {
        switch (slot) {
            case 0:
                this._gamePowerup1 = this._lockedPowerup;
                break;

            case 1:
                this._gamePowerup2 = this._lockedPowerup;
                break;

            case 2:
                this._gamePowerup3 = this._lockedPowerup;
                break;

            case 3:
                this._gamePowerup4 = this._lockedPowerup;
                break;
        }
    }

    showPowerups() {
        if (this._gamePowerup1) {
            this.ingameSlot1 = this._gamePowerup1;
        }
        if (this._gamePowerup2) {
            this.ingameSlot2 = this._gamePowerup2;
        }
        if (this._gamePowerup3) {
            this.ingameSlot3 = this._gamePowerup3;
        }
        if (this._gamePowerup4) {
            this.ingameSlot4 = this._gamePowerup4;
        }
        // if (spawnedFreezeDropButton) {
        //     Utils.SetActiveRecursively(spawnedFreezeDropButton, true);
        // }
    }

    hidePowerups() {
        this.ingameSlot1 = null;
        this.ingameSlot2 = null;
        this.ingameSlot3 = null;
        this.ingameSlot4 = null;
    }
}
